// CSRF token management utilities

// Generate a random token
const generateToken = () => {
  return Array.from(crypto.getRandomValues(new Uint8Array(32)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

// Set cookie with proper flags
const setCookie = (name, value, options = {}) => {
  const isSecure = window.location.protocol === "https:";
  const cookieParts = [`${name}=${value}`, "path=/"];

  // Only add secure flag if we're on HTTPS
  if (isSecure) {
    cookieParts.push("secure");
  }

  // Add SameSite flag
  cookieParts.push("samesite=strict");

  // Add expiration
  if (options.maxAge) {
    cookieParts.push(`max-age=${options.maxAge}`);
  }

  document.cookie = cookieParts.join("; ");
};

// Set CSRF token
export const setCsrfToken = () => {
  const token = generateToken();
  setCookie("csrf-token", token, { maxAge: 3600 });
  sessionStorage.setItem("csrf-token", token);
  return token;
};

// Get CSRF token
export const getCsrfToken = () => {
  // Try to get from cookie first
  const value = `; ${document.cookie}`;
  const parts = value.split(`; csrf-token=`);
  if (parts.length === 2) {
    const token = parts.pop().split(";").shift();
    if (token) return token;
  }

  // If not in cookie, try session storage
  const sessionToken = sessionStorage.getItem("csrf-token");
  if (sessionToken) {
    setCookie("csrf-token", sessionToken, { maxAge: 3600 });
    return sessionToken;
  }

  // Generate new token if none found
  return setCsrfToken();
};

// Get CSRF headers for API requests
export const getCsrfHeaders = () => {
  return {
    "X-CSRF-Token": getCsrfToken(),
    "Content-Type": "application/json",
  };
};

// Validate CSRF token
export const validateCsrfToken = (token) => {
  const cookieToken = getCsrfToken();
  const sessionToken = sessionStorage.getItem("csrf-token");
  return (
    cookieToken &&
    sessionToken &&
    token === cookieToken &&
    token === sessionToken
  );
};

// Clear CSRF token
export const clearCsrfToken = () => {
  setCookie("csrf-token", "", { maxAge: 0 });
  sessionStorage.removeItem("csrf-token");
};
